import styled from "styled-components";

type ButtonProps =
	| {
			light?: undefined;
			lighter?: boolean;
	  }
	| {
			light?: boolean;
			lighter?: undefined;
	  };
export const DefaultButton = styled.button<ButtonProps>`
	${({ theme, lighter }) => (lighter ? theme.textStyles.text : theme.textStyles.primaryBold)};
	cursor: pointer;
	border: none;
	outline: none;
	border-radius: 6px;
	padding: ${({ light, lighter }) => (lighter ? "6px 14px" : light ? "8px 40px" : "12px 40px")};
	line-height: 15px;
	background-color: ${({ theme }) => theme.colors.lightergray};
	color: ${({ theme }) => theme.colors.textSecondary};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background-color 0.2s linear;
	> span {
		${({ theme }) => theme.textStyles.secondaryFontFamily};
	}

	&:hover  {
		background-color: ${({ theme }) => theme.colors.lightgray};
	}

	&:disabled {
		pointer-events: none;
		background-color: ${({ theme }) => theme.colors.lightgray};
		color: ${({ theme }) => theme.colors.lightergray};
		box-shadow: none;
	}
`;
